import { useQuery } from '@apollo/client/react'
import { GET_ALERTS_QUERY } from '@/api/getAlerts' // Your defined query

export function usePageAlerts(path: string) {
  const { loading, error, data } = useQuery(GET_ALERTS_QUERY, {
    variables: { path },
    skip: !path,
    fetchPolicy: 'cache-first',
  })

  const alerts = data?.getAlerts?.map((alert) => ({
    __typename: alert.__typename,
    active: alert.active,
    content: alert.content,
    updatedAt: alert.updatedAt,
    button: alert.button,
    asset: alert.asset,
  }))

  return {
    loading,
    error,
    alerts,
  }
}
